import { useEffect } from 'react'
import { Select } from 'antd'
import Card from 'components/card/Card'
import { DropDownStockLocationStatus } from 'constants/dropdown'
import ButtonLink from 'components/button/Button'
import Errors from 'components/errors/Errors'
import StockLocationTable from './StockLocationTable'
import Pagination from 'components/pagination/Pagination'
import {
  AdminsEcommerceInventoryStockLocationListResponseItem,
  StockLocationStatusEnum,
} from 'generated/api'

interface Props {
  isLoadingStockLocations: boolean
  isFailedStockLocations: boolean
  statusStockLocation: StockLocationStatusEnum | string
  stockLocations: AdminsEcommerceInventoryStockLocationListResponseItem[]
  totalRows: number
  currentPage: number
  currentLimit: number
  onChangeStatusStockLocation: (status: StockLocationStatusEnum | string) => void
  onOpenCreateStockLocation: () => void
  onOpenUpdateStockLocation: (id: string) => void
  onChangePage: (page: number) => void
  onChangeLimit: (limit: number) => void
  fetchStockLocations: () => void
}

export default function StockLocationIndex(props: Props) {
  const {
    isLoadingStockLocations,
    isFailedStockLocations,
    statusStockLocation,
    stockLocations,
    totalRows,
    currentPage,
    currentLimit,
    onChangeStatusStockLocation,
    onOpenCreateStockLocation,
    onOpenUpdateStockLocation,
    onChangePage,
    onChangeLimit,
    fetchStockLocations,
  } = props

  useEffect(() => {
    fetchStockLocations()
  }, [])

  return (
    <Card
      loading={isLoadingStockLocations}
      dataTestId="card_stock_location"
      spinnerTestId="loader_stock_location"
      className="rounded-xl p-0 pb-2"
    >
      <Card.Header className="sticky-card-header block xl:flex py-2 px-4">
        <div className="xl:w-1/5 mb-4 xl:mb-0 self-center"></div>
        <div className="xl:w-4/5 mb-4 xl:mb-0">
          <div className="xl:flex xl:flex-row xl:gap-4">
            <div className="xl:w-3/5 mb-4 xl:mb-0"></div>
            <div className="xl:w-1/5 mb-4 xl:mb-0">
              <Select
                data-testid="select_stock_location_status"
                defaultValue={statusStockLocation}
                className="dropdown-search"
                style={{ height: 40 }}
                onChange={(val: StockLocationStatusEnum | string) =>
                  onChangeStatusStockLocation(val)
                }
              >
                {DropDownStockLocationStatus.map(item => {
                  return (
                    <Select.Option
                      data-testid={`select_stock_location_status_${item.value}`}
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </Select.Option>
                  )
                })}
              </Select>
            </div>
            <div className="xl:w-1/5 mb-4 xl:mb-0">
              <ButtonLink
                data-testid="button_add_stock_location"
                variant="solid-primary"
                block={true}
                label="Tambah"
                className="text-sm h-full"
                onClick={onOpenCreateStockLocation}
              />
            </div>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="mt-0">
        {isFailedStockLocations ? (
          <Errors
            dataTestId="fetch_stock_location_list"
            inverse={false}
            header="Mohon maaf, permintaan Anda tidak dapat diproses."
            paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
            button={true}
            buttonLabel="Coba lagi"
            buttonAction={() => fetchStockLocations()}
          />
        ) : (
          <StockLocationTable
            loading={false}
            data={stockLocations}
            onClickDetail={onOpenUpdateStockLocation}
          />
        )}
      </Card.Body>
      {totalRows > 10 && (
        <Card.Footer>
          <div className="px-4 py-3">
            <Pagination
              disabled={isLoadingStockLocations}
              setLimit={(limit: number) => onChangeLimit(limit)}
              onPageChanged={(page: number) => onChangePage(page)}
              totalRows={totalRows}
              currentPage={currentPage}
              limit={currentLimit}
              showLimitPage={true}
            />
          </div>
        </Card.Footer>
      )}
    </Card>
  )
}
